import React from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { connect } from 'dva';

class MessageDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
  }
  componentDidMount() {
    this.showMessage(this.props.message);
  }
  componentWillReceiveProps(nextProps) {
    this.showMessage(nextProps.message);
  }

  showMessage(msg) {
    if (msg && msg.content) {
      let { type, content, duration } = msg;
      type = type || 'info';
      duration = duration || 1.5;
      content = this.context.intl.messages[content] || content;
      message[type](content, duration);
      // reset message
      this.props.dispatch({ type: 'app/setMessage', payload: {} });
    }
  }

  render() {
    return null;
  }
}

MessageDisplay.propTypes = {
  dispatch: PropTypes.func,
  message: PropTypes.object,
};

MessageDisplay.contextTypes = {
  intl: PropTypes.object.isRequired,
};

// export default MessageDisplay;
export default connect(({ app }) => ({ message: app.message }))(MessageDisplay);



// WEBPACK FOOTER //
// ./src/components/Common/MessageDisplay.js